import { LOGO_VIEWBOX, logoColors, logoGeometry, logoText } from "@clinic/ui";
import { cn } from "@/lib/utils";

/** Stylized eye mark — outer almond, teal iris, dark pupil, dashed arcs. */
export function LogoIcon({ size = 32, className }: { size?: number; className?: string }) {
  const g = logoGeometry;
  const c = logoColors;
  return (
    <svg
      viewBox={LOGO_VIEWBOX}
      width={size}
      height={size}
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d={g.arcTop}
        stroke={c.arcs}
        strokeWidth={2}
        strokeDasharray="4 5"
        strokeLinecap="round"
      />
      <path
        d={g.arcBottom}
        stroke={c.arcs}
        strokeWidth={2}
        strokeDasharray="4 5"
        strokeLinecap="round"
      />
      <path d={g.eyeOutline} stroke={c.outline} strokeWidth={2.5} />
      <circle cx={g.iris.cx} cy={g.iris.cy} r={g.iris.r} fill={c.iris} />
      <circle cx={g.pupil.cx} cy={g.pupil.cy} r={g.pupil.r} fill={c.pupil} />
      <circle cx={g.highlight.cx} cy={g.highlight.cy} r={g.highlight.r} fill={c.highlight} />
    </svg>
  );
}

/** Icon + serif wordmark with teal divider and tagline. */
export function LogoFull({
  iconSize = 56,
  className,
  compact = false,
}: {
  iconSize?: number;
  className?: string;
  compact?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <LogoIcon size={iconSize} />
      <div>
        <div
          className="font-serif text-text"
          style={{ fontSize: compact ? 18 : 28, letterSpacing: "2px", lineHeight: 1.1 }}
        >
          {logoText.name}
        </div>
        <div
          className="font-serif text-accent-light"
          style={{ fontSize: compact ? 10 : 13, letterSpacing: "4px", marginTop: 2 }}
        >
          {logoText.sub}
        </div>
        <div className="my-2 h-px bg-accent" style={{ maxWidth: compact ? 140 : 230 }} />
        <div className="text-text-tertiary" style={{ fontSize: compact ? 8 : 11, letterSpacing: "2px" }}>
          {logoText.tagline}
        </div>
      </div>
    </div>
  );
}
